import {
  //Загрузка информации о консультанте
  CONSULTANT_INFO_LOADING_START,
  CONSULTANT_INFO_LOADED_SUCCESSFULLY,
  CONSULTANT_INFO_LOADING_FAILED,
} from '../actions/consultantInfo';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  cons_ready: false,
  cons_loading: false,
  consultant: {},
  
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    //Загрузка информации о консультанте
    case CONSULTANT_INFO_LOADING_START:
      return {
        ...state,
        cons_ready: false,
        cons_loading: true,
        consultant: {},
      };
    case CONSULTANT_INFO_LOADED_SUCCESSFULLY:
      return {
        ...state,
        cons_ready: true,
        cons_loading: false,
        consultant: action.payload.consultant,
      };
    case CONSULTANT_INFO_LOADING_FAILED:
      return {
        ...state,
        cons_ready: false,
        cons_loading: false,
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}